import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StoreModule } from "@ngrx/store";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { EffectsModule } from "@ngrx/effects";
import { authReducer, AUTH_INITIAL_STATE } from "./auth/auth.reducer";
import { AuthEffects } from "./auth/auth.effects";
import { AutoLogoutComponent } from "./auth/auto-logout-confirmation/auto-logout.component";
import { MatLegacyButtonModule } from "@angular/material/legacy-button";
import { MatLegacyDialogModule } from "@angular/material/legacy-dialog";
import { MatLegacySnackBarModule } from "@angular/material/legacy-snack-bar";
import { LoggingModule } from "@content-platform/web-angular-shared-util-logging";
import { WebAngularSharedUtilErrorHandlingModule } from "@content-platform/web-angular-shared-util-error-handling";
import { HandleAdCallbackResolver } from "./handle-ad-callback.resolver";
import { NotificationsModule } from "@content-platform/web-angular-shared-ui-notifications";
import { DevelopmentModule } from "@content-platform/web-angular-shared-util-development";
import { AuthLoggingTransformer } from "./auth-logging-transformer";
import { AuthReportTransformer } from "./auth-report-transformer";
import { AuthDebugFlags } from "./debug-flags";
import { MinutesSecondsPipe } from "./minutes-seconds.pipe";
import * as i0 from "@angular/core";
/**
 * AuthModule which includes the auth reducer and effects
 *
 * @export
 * @class AuthModule
 */
export class AuthModule {
    static { this.ɵfac = function AuthModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AuthModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AuthModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [AuthEffects, HandleAdCallbackResolver, provideHttpClient(withInterceptorsFromDi())], imports: [CommonModule,
            StoreModule.forFeature("auth", authReducer, { initialState: AUTH_INITIAL_STATE }),
            EffectsModule.forFeature([AuthEffects]),
            MatLegacySnackBarModule,
            LoggingModule.withExtraParams([AuthLoggingTransformer]),
            NotificationsModule,
            WebAngularSharedUtilErrorHandlingModule.withExtraParams(AuthReportTransformer),
            DevelopmentModule.withFlags(AuthDebugFlags),
            MatLegacyDialogModule,
            MatLegacyButtonModule] }); }
}
//# sourceMappingURL=auth.module.js.map